import { Component } from "react";
import { ButtonToolbar, ButtonGroup, Button, Modal, Alert } from "react-bootstrap";
import axiosInstance from "../../axiosInstance";
import { logOut, make_select_data } from "../helper";
import "../../css/ToolbarSelected.css"
import { withRouter } from "react-router-dom";
import { containsPermission } from './../helper';
import Select from 'react-select'
import axios from "axios";


class ToolbarSelected extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDeleteModal: false,
            next_stages: [],
            next_stage: null,
            contract_id: -1,
            can_close: false,
            showCloseModal: false,
            statuses_array: [],
            selected_status_id: null,
            source:axios.CancelToken.source(),
            alerts:{
                close_ticket_hidden:true,
                change_stage_hidden:true,
            }
        };
    }

    componentDidMount() {
        this._ismounted = true;
        this.fetch_next_stages();
        this.fetch_filter_statuses();
    }


    componentWillUnmount() {
        this.state.source.cancel()
    }

    fetch_filter_statuses() {
        axiosInstance.get('/tickets/statuses',{
            cancelToken:this.state.source.token
        })
            .then(response => {
                let statuses = make_select_data(response.data.data);
                this.setState({
                    statuses_array: statuses
                })
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_next_stages() {
        axiosInstance.get('tickets/stages/' + this.props.data.stage_id + '/type/' + this.props.data.type_id + '/auth',{
            cancelToken:this.state.source.token
        })
            .then(response => {
                this.setState({
                    next_stages: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }
    render_buttons() {
        let arr = [];
        let permissions = this.props.role_permissions;
        if (this.state.next_stages.length != 0 && this.props.data.status_id == 1 && containsPermission(permissions, 'tickets_stage.change')) {
            arr.push(
                <ButtonGroup key={2} className="mr-2">
                    <Button className="btn-success toolbar-btn" onClick={(e) => this.onChangeStageBtnClicked(this.props.data.id)}>მდგომარეობა</Button>
                </ButtonGroup>
            )
        }

        if (containsPermission(permissions, 'contracts.see')) {
            arr.push(
                <ButtonGroup key={3} className="mr-2">
                    <Button className="btn-info toolbar-btn" onClick={(e) => this.openContract()} >კონტრაქტი</Button>
                </ButtonGroup>
            )
        }
        if (containsPermission(permissions, 'tickets.edit')) {
            arr.push(
                <ButtonGroup key={1} className="mr-2">
                    <Button variant="warning" onClick={(e) => {
                        this.props.history.push("dashboard/update_ticket/" + this.props.data.id);
                    }
                    }>რედაქტირება</Button>
                </ButtonGroup>
            )
        }
        if (containsPermission(permissions, 'tickets.edit.status')) {
            arr.push(
                <ButtonGroup key={4} className="mr-2">
                    <Button variant="secondary toolbar-btn" onClick={(e) => this.onCloseTicketBtnClicked()}>სტატუსი</Button>
                </ButtonGroup>
            )
        }
        if (containsPermission(permissions, 'tickets.delete')) {
            arr.push(
                <ButtonGroup key={5} className="mr-2">
                    <Button className="btn-danger toolbar-btn" onClick={(e) => this.showDeleteModal()}>წაშლა</Button>
                </ButtonGroup>
            )
        }



        return arr
    }

    openContract() {
        let id = this.props.data.contract_id
        let account_id = this.props.data.account_id
        let first_name = this.props.data.first_name
        let second_name = this.props.data.second_name
        let personal_number = this.props.data.personal_number

        let query = "".concat(account_id, '/', first_name, '/', second_name, '/', personal_number);
        if (id === 1) {
            this.props.history.push("/pdf/new/" + query)
        } else if (id === 2) {
            this.props.history.push("/pdf/remove/" + query)
        } else if (id === 3) {
            this.props.history.push("/pdf/replace/" + query)
        }
    }

    redirctTo(id) {
        this.props.history.push("/dashboard/new_ticket/" + id);
    }

    showChangeStageModal() {
        if (this._ismounted) {
            this.setState(
                {
                    showModal: true,

                }
            )
        }

    }
    hideChangeStageModal() {
        if (this._ismounted) {
            this.setState(
                {
                    showModal: false
                }
            )
        }

    }
    onChangeStageBtnClicked(ticket_id) {
        this.showChangeStageModal();
    }


    // Close  ticket

    onCloseTicketBtnClicked() {
        if (this._ismounted) {
            this.setState({
                showCloseModal: true
            })
        }

    }

    on_status_change(e) {
        if (this._ismounted) {
            this.setState({
                selected_status_id: e.value,
                alerts:{
                    ...this.state.alerts,
                    close_ticket_hidden:true
                }
            })
        }
    }



    hideCloseModal() {
        if (this._ismounted) {
            this.setState({
                showCloseModal: false
            })
        }

    }

    closeTicket() {

        let status_id = parseInt(this.state.selected_status_id)
        if(!status_id){
            this.setState({
                alerts:{
                    ...this.state.alerts,
                    close_ticket_hidden:false
                }
            })
            return;
        }
        axiosInstance.put('/tickets/' + this.props.data.id, {
            status_id: status_id,
        })
        .then(response => this.on_stage_change_response())
        .catch(err => {
            if (err.response.status === 401) {
                logOut(this.props);
            }
        })
    }
    on_next_stage_select(e) {
        if (this._ismounted) {
            this.setState({
                next_stage: e.value,
                alerts:{
                    ...this.state.alerts,
                    change_stage_hidden:true
                }
            })
        }

    }
    on_stage_change_response() {
        this.hideChangeStageModal();
        this.props.updateTable()
    }

    on_change_stage_btn_click() {
        
        let stage_id = parseInt(this.state.next_stage)
        if(!stage_id){
            this.setState({
                alerts:{
                    ...this.state.alerts,
                    change_stage_hidden:false
                }
            })
            return;
        }
        axiosInstance.put('/tickets/' + this.props.data.id, {
            stage_id: stage_id,
        })
            .then(response => this.on_stage_change_response())
            .catch(err => {
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })

    }

    on_delete() {
        this.hideDeleteModal();
        this.props.updateTable()
    }

    hideDeleteModal() {
        if (this._ismounted) {
            this.setState(
                {
                    showDeleteModal: false
                }
            )
        }

    }

    showDeleteModal() {
        if (this._ismounted) {
            this.setState({
                showDeleteModal: true
            })
        }

    }

    deleteTicket() {
        axiosInstance.delete('/tickets/' + this.props.data.id)
            .then(response => this.on_delete())
            .catch(err => {
                if (err?.response.status === 401) {
                    logOut(this.props);
                }
            })
    }


    render() {
        let items = this.render_buttons();
        return (
            <div>
                <Modal
                    show={this.state.showModal}
                    onHide={(e) => this.hideChangeStageModal()}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            მდგომარეობის შეცვლა
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert variant="danger" hidden={this.state.alerts.change_stage_hidden}>აირჩიეთ მდგომარეობა</Alert>
                        <Select options={this.state.next_stages} onChange={(e) => this.on_next_stage_select(e)} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(e) => this.on_change_stage_btn_click()}>შეცვლა</Button>
                        <Button variant="danger" onClick={(e) => this.hideChangeStageModal()}>დახურვა</Button>
                    </Modal.Footer>
                </Modal>

                <ButtonToolbar>
                    {items}
                </ButtonToolbar>

                <Modal
                    show={this.state.showDeleteModal}
                    onHide={(e) => this.hideDeleteModal()}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            დავალების წაშლა
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        დანამდვილებით გსურთ დავალების წაშლა?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(e) => this.deleteTicket()}>დიახ</Button>
                        <Button variant="danger" onClick={(e) => this.hideDeleteModal()}>არა</Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={this.state.showCloseModal}
                    onHide={(e) => this.hideCloseModal()}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            დავალების დახურვა
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Alert variant='danger' hidden = {this.state.alerts.close_ticket_hidden} >აირჩიეთ სტატუსი</Alert>
                        <Select
                            value={this.state.selected_permissions}
                            options={this.state.statuses_array}
                            onChange={(e) => this.on_status_change(e)}
                            placeholder="აირჩიეთ სტატუსი"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(e) => this.closeTicket()}>დიახ</Button>
                        <Button variant="danger" onClick={(e) => this.hideCloseModal()}>არა</Button>
                    </Modal.Footer>
                </Modal>
            </div>

        )
    }
}
export default withRouter(ToolbarSelected)